import React from 'react';
import SolutionDetail from '../components/SolutionDetail';
import WaterIcon from '@mui/icons-material/Water';

const solutionData = {
  id: 'hydrographic-survey',
  name: 'Hydrographic Survey',
  icon: <WaterIcon sx={{ fontSize: 60 }} />,
  description: 'Comprehensive water body surveying and mapping',
  overview: `Geomaps Africa Ltd has the technical expertise to execute hydrographic surveys diligently. A Hydrographic Survey is basically the science of collecting survey measured information about the physical characteristics of water bodies that include water depths, water body boundaries/highest water mark, navigation channels as applicable in both inland and water ways like large lakes and the high seas. The possible products include creation of nautical charts used by mariners, water body delineation, engineering constructions and maintenance activities related to water bodies etc.`,
  features: [
    {
      title: 'Water Depth Measurement',
      description: 'Accurate measurement of water body depths',
    },
    {
      title: 'Boundary Mapping',
      description: 'Delineation of water body boundaries and high water marks',
    },
    {
      title: 'Navigation Channel Mapping',
      description: 'Detailed mapping of inland and sea navigation channels',
    },
    {
      title: 'Nautical Chart Creation',
      description: 'Professional charts for maritime navigation',
    },
    {
      title: 'Engineering Support',
      description: 'Data for construction and maintenance activities',
    },
  ],
  benefits: [
    'Accurate water body characterization',
    'Professional nautical charts',
    'Comprehensive boundary mapping',
    'Navigation channel documentation',
    'Engineering project support',
  ],
};

const HydrographicSurvey = () => {
  return <SolutionDetail solution={solutionData} />;
};

export default HydrographicSurvey; 